const focusAndClick = element => {
  if (element) {
    element.focus();
    element.click();
  }
};

export default focusAndClick;
